import React from "react";

const WhatWeDo = () => {
	return (
		<section className="bg-inherit mx-[1.5rem] mt-[4rem]">
			<div className="max-w-7xl">
				<div className="grid lg:grid-cols-2 gap-12 items-center">
					{/* Left Section - Text Content */}
					<div className="space-y-6">
						<div>
							{/* Title */}
							<h2 className="text-l font-light text-swift-dark uppercase tracking-wider font-generalSans">
								OUR RATIONALE
							</h2>

							{/* Main Heading */}
							<h3 className="text-2xl lg:text-3xl xl:text-4xl font-normal text-swift-pink font-generalSans">
								Why We Do What We Do
							</h3>
						</div>

						<div className="space-y-4 text-l font-light">
							{/* Paragraph 1  */}
							<p className="text-swift-dark leading-relaxed font-generalSans">
								For millions of girls across Africa, a period
								isn't a natural cycle; it’s a barrier. Without
								safe products, many are forced to use risky
								alternatives like rags and newspapers, leading
								to infections and shame. This directly causes
								them to miss up to 20% of the school year.
							</p>

							{/* Paragraph 2 */}
							<p className="text-swift-dark leading-relaxed font-generalSans">
								These aren’t just numbers; they are silenced
								voices and futures cut short.
							</p>

							{/* Paragraph 3*/}
							<p className="text-swift-dark leading-relaxed font-generalSans">
								At Swift Haven, we exist to restore dignity and
								opportunity, ensuring a period never stands in
								the way of a girl’s education or her dreams.
							</p>
						</div>
					</div>

					{/* Right Section - Photograph */}
					<div className="flex justify-center lg:justify-end">
						<div className="relative max-w-md w-full">
							<img
								src="/assets/images/Girls.JPG"
								alt="Two young children in an outdoor setting"
								className="w-full h-auto rounded-lg shadow-lg object-cover"
								style={{ maxHeight: "500px" }}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default WhatWeDo;
